import { Conversation } from '@/models/conversation'
import { User } from '@/models/user'
import { ROLES } from '@/shared/constants'

export function canUserAccessAllConversations(
  user: Pick<User, 'role'>
) {
  return [ROLES.COMPANY_ADMIN, ROLES.ATTENDANT].includes(user.role.id)
}

export function canUserUseShowAllConversationFilter(
  user: Pick<User, 'role'>
) {
  return (
    canUserAccessAllConversations(user) || user.role.id === ROLES.SPECIALIST
  )
}

export function userHasDepartmentAccess(
  departmentId?: number | null,
  userDepartmentIds?: number[]
) {
  if (!departmentId) return true

  return userDepartmentIds?.includes(departmentId) ?? false
}

export function isConversationAssignedToUser(
  conversation: Conversation,
  userId: number
) {
  return (
    conversation.secondaryUserId === userId || conversation.userId === userId
  )
}

export function canUserAccessConversation(
  conversation: Conversation,
  user: Pick<User, 'id' | 'role' | 'departmentIds'>
) {
  if (canUserAccessAllConversations(user)) return true

  if (user.role.id === ROLES.SPECIALIST) {
    return (
      (Boolean(conversation.departmentId) &&
        userHasDepartmentAccess(conversation.departmentId, user.departmentIds)) ||
      isConversationAssignedToUser(conversation, user.id)
    )
  }

  return false
}
